import * as React from 'react';

import Typography from '@material-ui/core/Typography';

import { FeatureFlagged, FeatureGatedVariant } from '../feature-gates/feature-flagged';
import { FeatureGates } from '../feature-gates/feature-gates';
import { UiMessageBanner } from '../ui/ui-message-banner';

import Message from './legacy-message';

import { PersonCanMessage } from '../util/can-message';

type Props = {
  canMessage: PersonCanMessage;
  contactType: ContactType;
};

export const ContactMessageErrors = (props: Props) => {
  const { canMessage, contactType } = props;
  const canTextInfo = canMessage.canTextMessage();
  const canEmailInfo = canMessage.canEmailMessage();

  return (
    <>
      <FeatureFlagged
        flagName={FeatureGates.INTEGRATED_MESSAGING}
        variant={FeatureGatedVariant.HIDE_ON_FLAG}
      >
        {!canTextInfo.canText && !canEmailInfo.canEmail && (
          <Message
            variant="error"
            canBeDismissed={false}
            message={`Phone number or email needs to be added in order to send messages to this ${
              contactType || 'person'
            }`}
            dataCy="contact-message-error"
          />
        )}
        {!canTextInfo.canText && canEmailInfo.canEmail && (
          <Message
            variant="warning"
            canBeDismissed={false}
            message={<Typography variant="body2">{canTextInfo.errorMessage}</Typography>}
            dataCy="contact-message-error"
          />
        )}
      </FeatureFlagged>
      <FeatureFlagged
        flagName={FeatureGates.INTEGRATED_MESSAGING}
        variant={FeatureGatedVariant.SHOW_ON_FLAG}
      >
        {!canTextInfo.canText && (
          <UiMessageBanner
            variant={canEmailInfo.canEmail ? 'attention' : 'error'}
            message={
              !canEmailInfo.canEmail
                ? `${canTextInfo.errorMessage}, and ${canEmailInfo.errorMessage}`
                : canTextInfo.errorMessage
            }
            dataCy="contact-message-error"
            className="u-borderRadius-5"
          />
        )}
      </FeatureFlagged>
    </>
  );
};
